import hdrm from '../../hdrm';
import actionTypes from '../constants/action-types';
import globals from '../../globals';
import { UPDATE_BOTH, UPDATE_STATIC_ONLY } from '../../hdrm/constants/update-strategies';
import DEFAULT_OPTIONS from '../constants/default-options';

const replaceElement = (element, targetElementId, initialOptions = {}) => {
  let { strategy } = initialOptions;

  if (!strategy) {
    strategy = hdrm.verifiers.hasElementAdditives(targetElementId)
      ? UPDATE_STATIC_ONLY
      : UPDATE_BOTH;
  }

  const options = {
    ...DEFAULT_OPTIONS,
    ...initialOptions,
    strategy,
  };

  return globals.helpers.globalActionExtender({
    type: actionTypes.REPLACE_ELEMENT,
    payload: {
      element,
      targetElementId,
      options,
    },
  });
};

export default replaceElement;
